module.exports = "/_next/static/images/video_id_7110539973685759275-68202c8bdf08936902cc33eabc403062.jpg";